import {
  TextInput,
  NumberInput,
  ReferenceInput,
  ReferenceArrayInput,
  SelectInput,
  AutocompleteInput,
  AutocompleteArrayInput,
  required,
  maxLength,
  minLength,
} from "react-admin";
import { Grid } from "@mui/material";
import { administrationRequests } from "api/administrationApi";
import { specialistRequests } from "api/specialistApi";

const NAMES_MAX_LENGTH = 200;
const CODE_MAX_LENGTH = 20;
const ORDINANCE_NUMBER_MAX_LENGTH = 300;

const SaveForm = () => {
  return (
    <Grid
      container
      spacing={2}
    >
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="nameBg"
          label="Име на български"
          validate={[required(), maxLength(NAMES_MAX_LENGTH), minLength(1)]}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={6}
      >
        <TextInput
          source="nameEn"
          label="Име на английски"
          validate={[required(), maxLength(NAMES_MAX_LENGTH), minLength(1)]}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="code"
          label="Код"
          validate={[required(), maxLength(CODE_MAX_LENGTH)]}
          fullWidth
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="laborCategory"
          reference={specialistRequests.getSpecializationLaborCategoriesSelect()}
        >
          <SelectInput
            optionText="nameBg"
            label="Категория труд"
            validate={[required()]}
            fullWidth
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="type"
          reference={specialistRequests.getSpecializationTypesSelect()}
        >
          <SelectInput
            optionText="nameBg"
            label="Тип"
            validate={[required()]}
            fullWidth
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceInput
          source="departmentId"
          reference={administrationRequests.getDepartmentsSelect()}
          filter={{ filterByUser: true }}
        >
          <AutocompleteInput
            optionText="name"
            label="Катедра"
            validate={[required()]}
            fullWidth
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <ReferenceArrayInput
          source="receptionTypeIds"
          reference={administrationRequests.getReceptionTypesSelect()}
        >
          <AutocompleteArrayInput
            optionText="name"
            label="Тип прием"
            validate={[required()]}
            fullWidth
          />
        </ReferenceArrayInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <NumberInput
          source="studyDuration"
          label="Продължителност на обучение (месеци)"
          validate={[required()]}
          fullWidth
          onWheel={e => e.target.blur()}
        />
      </Grid>
      <Grid
        item
        md={4}
        xs={12}
      >
        <ReferenceInput
          source="examId"
          reference={administrationRequests.getExamsSelect()}
        >
          <AutocompleteInput
            filterToQuery={q => (q?.length > 2 ? { name: q } : {})}
            optionText="name"
            label="Изпит"
            fullWidth
          />
        </ReferenceInput>
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <NumberInput
          source="wageIncreaseCoefficient"
          label="Коефициент за увеличение на заплата"
          validate={[required()]}
          fullWidth
          parse={v => (v === "" ? null : parseFloat(parseFloat(v).toFixed(2)))}
          format={v => (v !== undefined && v !== null && v !== "" ? Number(v).toFixed(2) : "")}
          onWheel={e => e.target.blur()}
        />
      </Grid>
      <Grid
        item
        xs={12}
        md={4}
      >
        <TextInput
          source="ordinanceNumber"
          label="Номер заповед"
          validate={[required(), maxLength(ORDINANCE_NUMBER_MAX_LENGTH)]}
        />
      </Grid>
    </Grid>
  );
};

export default SaveForm;
